import { useState } from "react";
import useScrollTop from "../../hooks/useScrollTop";
import BookmarksTab from "./BookmarksTab";
import PaymentsTab from "./PaymentsTab";
import ProfileTab from "./ProfileTab";
import PurchasesTab from "./PurchasesTab";

const PANEL =
  "mr-2 mt-[30px] w-[400px] rounded-lg bg-[#282828] py-6 pr-6 sm:mx-auto sm:mr-20 sm:w-[600px] md:w-[700px] lg:w-[1000px]";

// `boxed` controls whether the tab renders inside the grey card.
const TABS = [
  { icon: "person", label: "اطلاعات کاربری", Panel: ProfileTab, boxed: true },
  { icon: "bookmark", label: "نشان‌شده‌ها", Panel: BookmarksTab },
  { icon: "play_circle", label: "فیلم‌های من", Panel: PurchasesTab },
  { icon: "payment", label: "پرداخت‌ها", Panel: PaymentsTab, boxed: true },
];

const AccountPage = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  useScrollTop();

  const { Panel, boxed } = TABS[activeIndex];

  return (
    <div className="mb-[20rem]">
      <div className="flex w-full flex-col items-center">
        <div className="mr-2 mt-[100px] flex w-[400px] flex-col items-center justify-around gap-4 rounded-lg bg-[#282828] p-4 py-6 sm:w-[600px] sm:flex-row sm:pr-0 md:mr-20 md:w-[700px] lg:w-[1000px]">
          {TABS.map((tab, index) => (
            <button
              key={tab.label}
              type="button"
              onClick={() => setActiveIndex(index)}
              aria-pressed={index === activeIndex}
              className={`flex cursor-pointer items-center gap-2 text-base transition ${
                index === activeIndex
                  ? "text-brand"
                  : "text-white hover:text-brand"
              }`}
            >
              <span className="material-icons">{tab.icon}</span>
              <span className="ml-2">{tab.label}</span>
            </button>
          ))}
        </div>
      </div>

      <div className="flex w-full flex-col items-center">
        {boxed ? (
          <div className={PANEL}>
            <Panel />
          </div>
        ) : (
          <Panel />
        )}
      </div>
    </div>
  );
};

export default AccountPage;
